"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlock = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../Text");
var styles_1 = __importDefault(require("./styles"));
var formatters_1 = require("../../utils/formatters");
/**
 * @deprecated does not follow established patterns of pure components and containers
 */
exports.TextBlock = react_1.default.memo(function (_a) {
    var title = _a.title, titleBlock = _a.titleBlock, value = _a.value, format = _a.format, _b = _a.titleProps, titleProps = _b === void 0 ? {} : _b, _c = _a.valueProps, valueProps = _c === void 0 ? {} : _c;
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ sx: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "6px",
            whiteSpace: "pre-line",
        } }, { children: [title ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.title }, titleProps, { children: title }))) : undefined, titleBlock ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.title }, { children: titleBlock }))) : undefined, (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.content }, valueProps, { children: format ? formatters_1.formatters[format](value) : value }))] })));
});
exports.TextBlock.displayName = "TextBlock";
